module.exports = __webpack_public_path__ + "img/laser-blast.1f6156e9.svg";